
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/address-not-supported",
      function () {
        return require("private-next-pages/address-not-supported.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/address-not-supported"])
      });
    }
  